/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { RiTaskLine } from 'react-icons/ri';
import { FaRegNoteSticky } from 'react-icons/fa6';
import { AiOutlineMessage } from 'react-icons/ai';
import './contactverifier.css';
import Card from 'react-bootstrap/Card';
import Stickynotes from '../Stickynotes.js';

export const ContactActivity = ({ viewComponent, contactDetails }) => {
  const [email, setEmail] = useState('');

  useEffect(() => {}, []);

  return (
    <div>
      <div style={{ margin: '12px' }}>
        <h3 style={{ fontSize: '15px' }}>Contact Activity</h3>
        {viewComponent === 'task' ? (
          <Card style={{ marginBottom: '20px' }}>
            <div>
              <Card.Body style={{ height: '15px' }}>
                <h3 style={{ fontSize: '18px' }}>Tasks</h3>
              </Card.Body>
              <Card.Body>
                <p style={{ fontSize: '12px' }}>
                  Creating User Interfaces and Development asper Requirement{' '}
                  <RiTaskLine style={{ float: 'right', fontSize: '31px', marginTop: '-29px' }} />
                </p>
              </Card.Body>
            </div>
          </Card>
        ) : viewComponent === 'message' ? (
          <Card>
            <Card.Body style={{ height: '15px' }}>
              <h3 style={{ fontSize: '18px' }}>Messages</h3>
            </Card.Body>
            <Card.Body>
              <p style={{ fontSize: '12px' }}>Creating User Interfaces and Development asper Requirement</p>
              <AiOutlineMessage style={{ float: 'right', fontSize: '31px', marginTop: '-67px' }} />
            </Card.Body>
          </Card>
        ) : viewComponent === 'note' ? (
          <Card>
            <Card.Body>
              <h3 style={{ fontSize: '15px' }}>Notes</h3>

              <Stickynotes contactDetails={contactDetails} />
            </Card.Body>
          </Card>
        ) : null}
      </div>
    </div>
  );
};
export default ContactActivity;
